<template>
    <div class="hot_div">
        <div class="hot_list">
            <div class="flex_between div_title">
                <h4 class="title">会员详情</h4>
            </div>
            <div class="members flex_between">
                <div class="members_left" v-html="ruleObj.content">

                </div>
                <!-- <div class="members_right flex_start">
                    <i><img src="@/assets/img/huangguan.png" alt="">
                    </i>
                    <i><img src="@/assets/img/huangguanT.png" alt="">
                    </i>
                </div> -->
            </div>
            <div class="flex_between div_title">
                <h4 class="title">积分详情</h4>
            </div>
            <div class="integral flex_between members">
                <div class="integral_left" v-html="ruleObj.score">
                </div>
                <div class="integral_right">
                    <h5>积分记录</h5>
                    <div class="integral_list">
                        <div class="list_li flex_between" v-for="(liem, index) in lntegral_arr" :key="index">
                            <span class="time">{{liem.create_time}}</span>
                            <div class="li_text">
                                {{liem.type}}
                                <span>{{liem.change == 1 ? '+':'-'}}{{liem.score}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'popup',
        data() {
            return {
                ruleObj: {},//内容
                lntegral_arr: [],//积分明细
                page: 1,//翻页
            }
        },
        props: {

        },
        watch: {

        },
        methods: {
            geHome: function () {
                this.$router.replace('/');
            },
            getText() {//获取积分规则
                let that = this;
                this.$get('rule', {}).then(res => {
                    that.ruleObj = res.data;
                })
            },
            getLntegral() {//获取积分明细
                let that = this;
                if (this.page == 1) {
                    this.lntegral_arr = [];
                }
                this.$post('score_log', {
                    member_id: this.USER().id,
                    limit: 10,
                    page: this.page,
                }).then(res => {
                    that.lntegral_arr = that.lntegral_arr.concat(res.data.data);
                })
            },


        },
        mounted() {
            this.getText();
            this.getLntegral();
            let that = this;
            $('.integral_right').scroll(function () {
                var scrollTop = $(this).scrollTop();
                var scrollHeight = $('.integral_list').height();
                var windowHeight = $(this).height();
                if (scrollTop + windowHeight + 37 >= scrollHeight) {
                    that.page++;
                    that.getLntegral();
                }
            });
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .div_title {
        border-bottom: 1px solid #DFDFDF;
    }

    .div_title .title {
        font-size: 16px;
        color: #1a1a1a;
        margin-bottom: 10px;
    }

    .members {
        padding: 20px 0;
        align-items: flex-start;
    }

    .members_left {
        color: #333;
        font-size: 16px;
        line-height: 1.6em;
        width: 60%;
        padding-right: 20px;
    }

    .members_right {
        flex: 1;
    }

    .members_right>i {
        width: 100px;
        height: 100px;
        margin-right: 50px;
    }

    .integral .integral_left {
        width: 55%;

        padding-right: 10px;
        font-size: 16px;
        line-height: 1.6em;
    }

    .integral {
        align-items: flex-start;
    }

    .integral .integral_right {
        flex: 1;
        padding-left: 20px;
        border-left: 1px solid #DFDFDF;
        height: 60vh;
        overflow-y: auto;
    }

    .integral_right>h5 {
        color: #333;
        font-size: 16px;
        text-align: center;
        margin-bottom: 20px;
    }

    .integral_right .integral_list .list_li {
        margin-bottom: 20px;
        align-items: center;
    }

    .integral_right .integral_list .list_li .time {
        width: 30%;
        color: #999;
        font-size: 14px;
    }

    .integral_right .integral_list .list_li .li_text {
        flex: 1;
        font-size: 14px;
        margin-left: 10px;
        color: #333;
    }

    .integral_right .integral_list .list_li .li_text>span {
        color: #F5AB16;
    }
</style>



// WEBPACK FOOTER //
// src/components/pc_viwe/my_rules.vue